
import gsap from 'gsap'
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import ScrollToPlugin from 'gsap/ScrollToPlugin.js';
gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import stage from '../components/stage'

import loadComponents from 'gia/loadComponents';
import config from 'gia/config';


import Highway from './highway';
import CustomRenderer from './custom-renderer';
import ProjectRenderer from './project-renderer';
import CustomTransition from './custom-transition';
import {Howl, Howler} from 'howler';

import lazySizes from 'lazysizes';
import VanillaTilt from '../components/vanilla-tilt.js';

class App {

  constructor($) {
    this.create()
  }

  create() {

      lazySizes.init()
      //config.set('log', false); // disables unnecessary console.log calls


      const H = window.H = new Highway.Core({
        renderers: {
          book: ProjectRenderer,
          project: ProjectRenderer,
          home: CustomRenderer
        },
        transitions: {
          default: CustomTransition
        }
      });

      H.on('NAVIGATE_END', ({
        to,
        trigger,
        location
      }) => {

       

        if (location.anchor) {

          const el = document.querySelector(location.anchor);

          if (el) {
            
            gsap.to(window, {
              duration: 0.1,
              scrollTo: el.getBoundingClientRect().top + stage.scrolltop
            });
          }
        } else {
           gsap.to(window, {
             duration: 0.1,
             scrollTo: 0
           });
        }
      });

      const links = document.querySelectorAll('.menu a');
      

      // Listen the `NAVIGATE_IN` event
      // This event is sent everytime a `data-router-view` is added to the DOM Tree
      H.on('NAVIGATE_IN', ({
        to,
        location
      }) => {
        // Check Active Link
        for (let i = 0; i < links.length; i++) {
          const link = links[i];

          // Clean class
          link.classList.remove('is-active');
          // Active link
          if (link.href === location.href) {
            link.classList.add('is-active');
          }
        }
      });

      Howler.mute(true)
      Howler.volume(0)
      
      $('.volume').on('click', (e) => {

         $('.volume').toggleClass('volume--muted')
        
          
        
          if ($('.volume').hasClass('volume--muted')){
            Howler.mute(true)
            Howler.volume(0)
          }
          else {
            Howler.mute(false)
            Howler.volume(1)
          }
      })

      
      
      
      
      
      
      


      $('body').addClass('loaded')

       

     
     

  }


}

module.exports = App
